import items1 from "../../asserts/images/gallery/image (1).jpeg";
import items2 from "../../asserts/images/gallery/image (2).jpeg";
import items3 from "../../asserts/images/gallery/image (3).jpeg";
import items4 from "../../asserts/images/gallery/image (4).jpeg";
import items5 from "../../asserts/images/gallery/image (5).jpeg";
import items6 from "../../asserts/images/gallery/image (6).jpeg";
import items7 from "../../asserts/images/gallery/image (7).jpeg";
import items8 from "../../asserts/images/gallery/image (8).jpeg";
import items9 from "../../asserts/images/gallery/image (9).jpeg";
import items10 from "../../asserts/images/gallery/image (10).jpeg";
import items11 from "../../asserts/images/gallery/image (11).jpeg";
import items12 from "../../asserts/images/gallery/image (12).jpeg";
import items13 from "../../asserts/images/gallery/image (13).jpeg";
import items14 from "../../asserts/images/gallery/image (14).jpeg";
import items15 from "../../asserts/images/gallery/image (15).jpeg";
import items16 from "../../asserts/images/gallery/image (16).jpeg";
import items17 from "../../asserts/images/gallery/image (17).jpeg";
import items18 from "../../asserts/images/gallery/image (18).jpeg";
import items19 from "../../asserts/images/gallery/image (19).jpeg";
import items20 from "../../asserts/images/gallery/image (20).jpeg";
import items21 from "../../asserts/images/gallery/image (21).jpeg";
import items22 from "../../asserts/images/gallery/image (22).jpeg";
import items23 from "../../asserts/images/gallery/image (23).jpeg";
import items24 from "../../asserts/images/gallery/image (24).jpeg";
import items25 from "../../asserts/images/gallery/image (25).jpeg";
import items26 from "../../asserts/images/gallery/image (26).jpeg";
import items27 from "../../asserts/images/gallery/image (27).jpeg";
import items28 from "../../asserts/images/gallery/image (28).jpeg";
import items29 from "../../asserts/images/gallery/image (29).jpeg";
import items30 from "../../asserts/images/gallery/image (30).jpeg";
import items31 from "../../asserts/images/gallery/image (31).jpeg";
import items32 from "../../asserts/images/gallery/image (32).jpeg";
import items33 from "../../asserts/images/gallery/image (33).jpeg";

import "./gallery_photos.scss"
const Items = () => {
  return <div className="items-box">
    <div className="row item-row">
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items1} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items2} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items3} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items4} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items5} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items6} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items7} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items8} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items9} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items10} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items11} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items12} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items13} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items14} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items15} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items16} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items17} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items18} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items19} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items20} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items21} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items22} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items23} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items24} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items25} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items26} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items27} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items28} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items29} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items30} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items31} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items32} alt="" /></div>
      <div className="col-lg-3 col-md-4 col-sm-6 my-4"><img src={items33} alt="" /></div>
    </div>
  </div>;
};
export default Items;
